import {
  AuthExtensionApi,
  InvalidateUserTokensBeforeDateRequest,
  RequestOptions,
} from './api';
import crossFetch from 'cross-fetch';
import { handleFailedResponse } from '@agilelab/plugin-wb-platform-common';
import { DiscoveryApi, FetchApi } from '@mainstage/core-plugin-api';

export class AuthExtensionClient implements AuthExtensionApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi?: { fetch: typeof fetch };
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi || { fetch: crossFetch };
  }

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('auth-extension');
  }

  async invalidateUserTokens(
    request: InvalidateUserTokensBeforeDateRequest,
    options?: RequestOptions,
  ): Promise<void> {
    const baseUrl = await this.getBaseUrl();
    const userRef = request.userRef;
    let response;

    if (userRef) {
      response = await this.fetchApi.fetch(`${baseUrl}/token-blacklist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
        },
        body: JSON.stringify({ userRef }),
      });
    } else {
      response = await this.fetchApi.fetch(`${baseUrl}/token-blacklist/me`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
        },
      });
    }

    await handleFailedResponse(response);
  }
}
